// @ts-nocheck
import { BasicSelect } from 'ui/selects';
import { PurpleSelectTrigger } from 'modules/predictiveGoals/components/queryBuilder/components/pgQueryBuilderEnhancements/PurpleSelectTrigger';
import type { PredictiveGoalQuery } from 'modules/predictiveGoals/types';
import { PLACEHOLDER_SELECT_A_VALUE } from 'modules/predictiveGoals/constants';
import { StyledPurpleSelectWrapper } from 'modules/predictiveGoals/components/queryBuilder/components/pgQueryBuilderEnhancements/styles';
import { EventConditionInputContainer } from '../Styled';

type WindowConditionProps = {
  id: string;
  query: PredictiveGoalQuery;
  onUpdate?: () => void;
  durations?: any[];
};

export const WindowCondition = ({ id, onUpdate, query, durations }: WindowConditionProps) => {
  const updateWindowValue = (windowValue) => {
    onUpdate(windowValue);
  };

  return (
    <EventConditionInputContainer data-test={`${id}_WindowCondition`}>
      {
        <BasicSelect
          id={`${id}_WindowConditionValues`}
          defaultValues={[query]}
          options={durations}
          onSelect={([windowValue]) => updateWindowValue(windowValue)}
          SelectWrapper={StyledPurpleSelectWrapper}
          Trigger={PurpleSelectTrigger}
          placeholder={PLACEHOLDER_SELECT_A_VALUE}
        />
      }
    </EventConditionInputContainer>
  );
};
